function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelectArrowBlack = function SvgSelectArrowBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M503.816,130.068L487.045,113.18C481.767,107.906 474.744,105 467.239,105C459.738,105 452.707,107.906 447.429,113.18L256.114,304.503L64.579,112.968C59.309,107.694 52.279,104.792 44.777,104.792C37.276,104.792 30.242,107.694 24.967,112.968L8.192,129.751C-2.731,140.666 -2.731,158.444 8.192,169.359L236.238,398.225C241.508,403.495 248.53,407.208 256.098,407.208L256.185,407.208C263.69,407.208 270.713,403.49 275.983,398.225L503.816,169.979C509.094,164.709 511.992,157.475 512,149.974C512,142.468 509.094,135.334 503.816,130.068Z",
    style: {
      fill: "rgb(0,0,0)",
      fillRule: "nonzero"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectArrowBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/select-arrow-black.2c6c4b2f.svg";
export { ForwardRef as ReactComponent };